import { FormEvent, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { authApi } from '../../services/api';
import { AuthLayout, Fehlermeldung } from './AuthLayout';

export default function EmailBestaetigenPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const benutzerId = Number(params.get('benutzer'));

  const [code, setCode] = useState(params.get('code') ?? '');
  const [fehler, setFehler] = useState<unknown>(null);
  const [laeuft, setLaeuft] = useState(false);

  async function absenden(e: FormEvent) {
    e.preventDefault();
    setFehler(null);
    setLaeuft(true);
    try {
      await authApi.emailBestaetigen({ benutzer_id: benutzerId, code });
      navigate('/login?bestaetigt=1', { replace: true });
    } catch (err) {
      setFehler(err);
    } finally {
      setLaeuft(false);
    }
  }

  if (!benutzerId) {
    return (
      <AuthLayout titel="Bestätigung nicht möglich">
        <p className="text-sm text-gray-600">
          Dieser Link ist unvollständig. Bitte rufen Sie ihn aus der
          Bestätigungsmail erneut auf.
        </p>
        <Link to="/login" className="mt-4 inline-block text-sm text-primary-600 hover:underline">
          Zur Anmeldung
        </Link>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout
      titel="E-Mail bestätigen"
      untertitel="Geben Sie den Code aus der Bestätigungsmail ein."
    >
      <Fehlermeldung fehler={fehler} />

      <form onSubmit={absenden} className="space-y-4">
        <input
          inputMode="numeric"
          pattern="[0-9]{6}"
          maxLength={6}
          required
          autoFocus
          value={code}
          onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))}
          className="w-full rounded-md border border-gray-300 px-3 py-2 text-center text-2xl tracking-[0.5em] focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500"
        />
        <button
          type="submit"
          disabled={laeuft || code.length !== 6}
          className="flex w-full items-center justify-center rounded-md bg-primary-600 px-4 py-2 text-sm font-medium text-white hover:bg-primary-700 disabled:opacity-60"
        >
          {laeuft && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
          Bestätigen
        </button>
      </form>
    </AuthLayout>
  );
}
